const initCtaFormSwitch = () => {
  const panes = document.querySelectorAll('.cta-form-pane')

  if (!panes.length) return

  const triggers = []

  panes.forEach((pane) => {
    const wrap = document.querySelector('.cta-callout [data-cta-index="' + pane.dataset.ctaForm + '"]')
    if (!wrap) return
    const trigger = wrap.querySelector('a, button') || wrap
    trigger.dataset.ctaTarget = pane.id
    triggers.push(trigger)
  })

  if (!triggers.length) return

  const paneIds = Array.from(panes).map((pane) => pane.id)

  const activate = (targetId) => {
    panes.forEach((pane) => {
      pane.classList.toggle('is-active', pane.id === targetId)
    })

    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.ctaTarget === targetId
      trigger.classList.toggle('is-active', isActive)
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      activate(trigger.dataset.ctaTarget)
      const target = document.getElementById(trigger.dataset.ctaTarget)
      if (target) target.scrollIntoView({ behavior: 'smooth' })
    })
  })

  const idFromHash = window.location.hash.replace('#', '')
  const hasHashTarget = paneIds.indexOf(idFromHash) !== -1

  activate(hasHashTarget ? idFromHash : triggers[0].dataset.ctaTarget)

  if (hasHashTarget) {
    document.getElementById(idFromHash).scrollIntoView({ behavior: 'smooth' })
  }

  window.addEventListener('hashchange', () => {
    const id = window.location.hash.replace('#', '')
    if (paneIds.indexOf(id) === -1) return
    activate(id)
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCtaFormSwitch)
} else {
  initCtaFormSwitch()
}
